import { createStore } from "easy-peasy";
import storeModel from "./model/index";

const store = createStore(storeModel);

export default store;
